export default class Query {
  response: Promise<any>;

  constructor(uri: string, data?: any, method?: string, options?: RequestInit) {
    const isGet = method?.toUpperCase() === 'GET';
    
    const fetchWithTimeout = (url: string, options: RequestInit, timeout = 30000): Promise<Response> => {
      return new Promise((resolve, reject) => {
        if (options.signal && options.signal.aborted) {
          return reject(new Error('AbortError'));
        }
        
        let timeoutController: AbortController | null = null;
        let timeoutId: ReturnType<typeof setTimeout> | null = null;
        
        if (!options.signal) {
          timeoutController = new AbortController();
          timeoutId = setTimeout(() => {
            if (timeoutController) {
              timeoutController.abort();
            }
            reject(new Error(`Request timeout for ${url}`));
          }, timeout);
          
          options = {
            ...options,
            signal: timeoutController.signal
          };
        }
        
        fetch(url, options)
          .then(resolve)
          .catch((error) => {
            if (error && error.name === 'AbortError') {
              const abortError = new Error('AbortError');
              abortError.name = 'AbortError';
              reject(abortError);
            } else {
              reject(error);
            }
          })
          .finally(() => {
            if (timeoutId) {
              clearTimeout(timeoutId);
            }
          });
      });
    };
    
    const requestOptions: RequestInit = {
      method: method || 'POST',
      body: (!isGet && data) ? JSON.stringify(data) : undefined,
      headers: {
        'Accept': 'application/json',
        ...(isGet ? {} : { 'Content-Type': 'application/json' })
      },
      ...options
    };
    
    this.response = fetchWithTimeout(
      uri, 
      requestOptions, 
      (options as any)?.timeout ?? 30000
    ).then(async res => {
      try {
        const text = await res.text();
        
        if (!res.ok) {
          throw new Error(`API Error (${res.status}): ${text}`);
        }
        
        try {
          return JSON.parse(text);
        } catch (e) {
          throw new Error(`Invalid JSON response: ${text}`);
        }
      } catch (error) {
        if (error && typeof error === 'object' && 'name' in error && (error as any).name === 'AbortError') {
          const abortError = new Error('AbortError');
          abortError.name = 'AbortError';
          throw abortError;
        }
        throw error;
      }
    });
  }
} 